(async () => {

  if (!customElements.get('logo-swiper')) {

    const Swiper = (await import('swiper')).default;
    const { Autoplay, Navigation, Pagination, Scrollbar } = await import('swiper/modules');

    // Modules are now included in the Swiper constructor options

    class LogoSwiper extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector('[data-swiper-logo-slider]');
        this.swiperOptions = {
          modules: [Navigation, Pagination, Scrollbar, Autoplay],
          threshold: 10,
        };

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);

          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            }
          }
        }

        // re-init slider when Theme Editor is active
        if (Shopify.designMode && this.swiperElement) {

          // Update the swiper
          window.addEventListener('shopify:section:load', (event) => {
            this.handleSectionDesignMode(event);
          });

          // Slide to the slide when a specific block is selected
          window.addEventListener('shopify:block:select', (event) => {
            this.handleSectionDesignMode(event);
          });

          // When on block deselect go to the slide in front-end
          window.addEventListener('shopify:block:deselect', (event) => {
            this.handleSectionDesignMode(event);
          });

        }
        this.init();
      }

      init() {
        this.swiper = new Swiper(this.swiperElement, this.swiperOptions);
      }

      /**
       * Handles the theme editor block change/edit event
       * @param {Object} event
       */
      handleSectionDesignMode(event) {

        this.swiper.update();

        if (this.swiperOptions.navigation) {
          this.swiper.navigation.init();
          this.swiper.navigation.update();
        }

        // Check if the slide index is set
        if (!("swiperSlideIndex" in event.target.dataset)) { return; }

        // Set the slide index based on loop settings or not
        let swipeToSlideIndex = parseInt(event.target.dataset.swiperSlideIndex) - 1;
        if(this.swiperOptions.loop) {
          swipeToSlideIndex = parseInt(event.target.dataset.swiperSlideIndex) + 1;
        }

        // Slide to slide based on the data attribute from the target
        this.swiper.slideTo(swipeToSlideIndex, 1000);

      }
    }

    window.LogoSwiper = LogoSwiper;

    customElements.define('logo-swiper', LogoSwiper);

  }

})();
